import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {BaseDatabaseService} from '../databaseServices/BaseDatabaseService';
import * as firebase from 'firebase';
import {Token} from '../../../pay-method/Token';
import {Payer} from '../../classes/Payer';
import {GoPay} from '../../classes/GoPay';
import {PayInfo} from '../../classes/PayInfo';

const httpOptions = {
  headers: new HttpHeaders(
    {
      'Content-Type':  'application/json'
      // 'Authorization': 'my-auth-token'
    }
  )
};

const RUN_LOCAL = false;
const LOMENO = '/';
@Injectable({
  providedIn: 'root'
})
export class PayService extends BaseDatabaseService {

  allow;

  payInfo: PayInfo;
  returnFormId;

  goPayDetail: GoPay = undefined;

  private static GET_TOKEN_LOCAL = 'http://localhost:5001/time4race-6be4a/us-central1/getPayToken';
  private static GET_TOKEN = 'https://us-central1-time4race-6be4a.cloudfunctions.net/getPayToken';
  private static STANDARD_PAY_LOCAL = 'http://localhost:5001/time4race-6be4a/us-central1/pay';
  private static STANDARD_PAY = 'https://us-central1-time4race-6be4a.cloudfunctions.net/pay';
  private static RETURN_URL_LOCAL = 'http://localhost:4200/home';
  private static RETURN_URL = 'https://time4race-6be4a.firebaseapp.com/home';
  private static GET_PAY_STATUS_LOCAL = 'http://localhost:5001/time4race-6be4a/us-central1/getPayStatus';
  private static GET_PAY_STATUS = 'https://us-central1-time4race-6be4a.cloudfunctions.net/getPayStatus';


  constructor(private httpClient: HttpClient) {
    super();
  }

  getToken(goPay?: GoPay | any) {
    const url = RUN_LOCAL ? PayService.GET_TOKEN_LOCAL : PayService.GET_TOKEN;
    goPay = goPay !== undefined ? goPay : {};
    let body = {};
    if(goPay !== undefined) {
      body = {
        clientId: goPay.clientId,
        clientSecret: goPay.clientSecret
      };
    }
    return this.httpClient.post(url, body, httpOptions).toPromise();
  }

  standardPay(token: Token,
              payer: Payer,
              amount: number,
              orderDescription: string,
              returnUrl: string,
              ean: string,
              itemName: string,
              productUrl: string,
              currency: string,
              goId: string) {
    const url = RUN_LOCAL ? PayService.STANDARD_PAY_LOCAL : PayService.STANDARD_PAY;
    // httpOptions.headers.set('Authorization', `${token.tokenType} ${token.accessToken}`);
    httpOptions.headers.set('Accept', 'application/json');
    const body = {token: token.access_token, payer: payer, amount: amount, orderDescription: orderDescription, returnUrl: returnUrl,
    ean: ean, itemName: itemName, productUrl: productUrl, currency: currency, goId: goId};
    return this.httpClient.post(url, body , httpOptions).toPromise();
  }

  getStateOfPay(token: Token, id: string) {
    const url = RUN_LOCAL ? PayService.GET_PAY_STATUS_LOCAL : PayService.GET_PAY_STATUS;
    httpOptions.headers.set('Accept', 'application/json');
    const body = {
      token: token.access_token,
      id: id
    };
    return this.httpClient.post(url, body, httpOptions).toPromise();
  }

  createPayForm() {
    let pay = firebase.functions().httpsCallable('pay');
    pay({}).then((result) => {

    });
  }

  getReturnUrl() {
    return RUN_LOCAL ? PayService.RETURN_URL_LOCAL : PayService.RETURN_URL;
  }
}
